import { connect } from "react-redux";
import Promotions from "./promotions";
import { loadPromotions } from "../orderBuilder/store/action-creators";
import {
  getPromotionsData,
  getPromotionsStatus,
} from "../orderBuilder/store/selectors";
import { getProfileData } from "../login/store/selectors";

const mapStateToProps = (state) => ({
  profileData: getProfileData(state),
  promotionsData: getPromotionsData(state),
  promotionsStatus: getPromotionsStatus(state),
});

export default connect(mapStateToProps, { loadPromotions })(Promotions);
